var _this = this;
import * as tslib_1 from "tslib";
import { setTimezone } from 'owa-service/lib/config';
import { setDateFormat, setTimeFormat } from 'owa-datetime-store';
import { updateSessionSettings, updateUserOptions } from 'owa-options-core';
import { logCurrentTimeZoneQuick, logDateFormatQuick, logTimeFormatQuick, } from '../utils/logDataOnSaveRegionalOptions';
import hasTimeZoneChanged from '../utils/hasTimeZoneChanged';
import hasLanguageChanged from '../utils/hasLanguageChanged';
import getNewDateFormat from '../utils/getNewDateFormat';
import getNewTimeFormat from '../utils/getNewTimeFormat';
import getUserCulture from '../utils/getUserCulture';
import getNewTimeZone from '../utils/getNewTimeZone';
import localeHotReload from '../utils/localeHotReload';
import getRegionalOptionsServiceRequests from '../utils/getRegionalOptionsServiceRequests';
import updateRegionalOptions from '../data/actions/updateRegionalOptions';
export default function saveRegionalOption() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var languageHasChanged, userCulture, newDateFormat, newTimeFormat, timeZoneHasChanged, newTimeZone, promises;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    languageHasChanged = hasLanguageChanged();
                    userCulture = getUserCulture();
                    updateSessionSettings({ UserCulture: userCulture });
                    newDateFormat = getNewDateFormat();
                    setDateFormat(newDateFormat);
                    newTimeFormat = getNewTimeFormat();
                    setTimeFormat(newTimeFormat);
                    timeZoneHasChanged = hasTimeZoneChanged();
                    newTimeZone = getNewTimeZone();
                    setTimezone(newTimeZone);
                    // Save the new values to UserOptions
                    updateUserOptions({
                        DateFormat: newDateFormat,
                        TimeFormat: newTimeFormat,
                        TimeZone: newTimeZone,
                    });
                    promises = getRegionalOptionsServiceRequests(languageHasChanged, timeZoneHasChanged);
                    return [4 /*yield*/, Promise.all(promises)];
                case 1:
                    _a.sent();
                    /**
                     * Action dispatched to call an orchestrator in owa-calendar which will initialize surface options.
                     */
                    updateRegionalOptions();
                    localeHotReload(languageHasChanged);
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * Saves the newTimeZone value, used in quickSettings
 */
export var saveTimeZoneSelection = function (newTimeZone) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var timeZoneHasChanged, promises;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                timeZoneHasChanged = hasTimeZoneChanged(newTimeZone);
                setTimezone(newTimeZone);
                updateUserOptions({
                    TimeZone: newTimeZone,
                });
                promises = getRegionalOptionsServiceRequests(false, timeZoneHasChanged);
                return [4 /*yield*/, Promise.all(promises)];
            case 1:
                _a.sent();
                logCurrentTimeZoneQuick();
                return [2 /*return*/];
        }
    });
}); };
/**
 * Saves the newDateFormat value, used in quickSettings
 */
export var saveDateFormatSelection = function (newDateFormat) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var promises;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                setDateFormat(newDateFormat);
                updateUserOptions({
                    DateFormat: newDateFormat,
                });
                promises = getRegionalOptionsServiceRequests(false, false);
                return [4 /*yield*/, Promise.all(promises)];
            case 1:
                _a.sent();
                logDateFormatQuick();
                return [2 /*return*/];
        }
    });
}); };
/**
 * Saves the newTimeFormat value, used in quickSettings
 */
export var saveTimeFormatSelection = function (newTimeFormat) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var promises;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                setTimeFormat(newTimeFormat);
                updateUserOptions({
                    TimeFormat: newTimeFormat,
                });
                promises = getRegionalOptionsServiceRequests(false, false);
                return [4 /*yield*/, Promise.all(promises)];
            case 1:
                _a.sent();
                logTimeFormatQuick();
                return [2 /*return*/];
        }
    });
}); };
//# sourceMappingURL=saveRegionalOption.js.map